import React, { useMemo, useState, useEffect } from "react"

import { Container, CardBody, Card } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import { axiosbaseurl } from "configure"
import moment from "moment"

import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"
import practice_logo from "../../assets/images/users/profile.png"
// import { socket } from "helpers/Connection"

const ActiveTimers = () => {
  const [table_data, settable_data] = useState([])
  // const [timer, settimer] = useState(false)

  const getLogsData = async () => {
    try {
      const response = await axiosbaseurl.get(
        `/task-updates/active/employee/timer`
      )
      if (response.data.success) {
        settable_data(response.data.taskLogs)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // useEffect(() => {
  //   const handleTimerStartEvent = data => {
  //     try {
  //       if (data.timer) {
  //         settimer(true)
  //       }
  //     } catch (error) {
  //       console.error("Error starting timer through socket connection:", error)
  //     }
  //   }

  //   const handleTimerStopEvent = data => {
  //     try {
  //       if (data.timer) {
  //         settimer(false)
  //       }
  //     } catch (error) {
  //       console.error("Error starting timer through socket connection:", error)
  //     }
  //   }

  //   socket.on("timerStarted", handleTimerStartEvent)
  //   socket.on("timerStopped", handleTimerStopEvent)

  //   return () => {
  //     socket.off("timerStarted")
  //     socket.off("timerStopped")
  //   }
  // }, [])

  useEffect(() => {
    getLogsData()

    const interval = setInterval(getLogsData, 5000)

    return () => clearInterval(interval)
  }, [])

  // useEffect(() => {
  //   getLogsData()

  //   // const interval = setInterval(getLogsData, 5000)

  //   // return () => clearInterval(interval)
  // }, [timer])

  document.title = "Active Employee Timer | Peacock Accountants Limited"

  return (
    <>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={"Active Employee Timer"}
          />
          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent
                table_data={table_data}
                getLogsData={getLogsData}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({ table_data }) => {
  const { checkAccess } = usePermissionData()
  const module_id = 24

  const navigate = useNavigate()

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: "text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Employee",
        accessor: "employee",
        disableFilters: true,
        filterable: true,
        className: "col-2",
        Cell: cellProps => {
          return (
            <div className="d-flex align-items-center ">
              <div className="text-center employee-margin-right">
                <img
                  src={
                    cellProps.row.original?.employee.profilePhoto
                      ? `${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original?.employee.profilePhoto}`
                      : practice_logo // Fallback to default image
                  }
                  alt="img"
                  className="rounded-circle"
                  width={35}
                  height={35}
                />
              </div>
              <div>
                {cellProps.row.original?.employee.name}{" "}
                {cellProps.row.original?.employee.lastName}
              </div>
            </div>
          )
        },
      },
      {
        Header: "Task Name",
        accessor: "task",
        disableFilters: true,
        filterable: true,
        className: "col-3",
        Cell: cellProps => {
          return <span>{cellProps.row.original.task.title}</span>
        },
      },
      {
        Header: "Client Code",
        accessor: "client",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <span>{cellProps.row.original.task.client.clientCode}</span>
        },
      },
      {
        Header: "Client Name",
        accessor: "clientcna",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <span>{cellProps.row.original.task.client.clientName}</span>
        },
      },
      {
        Header: "Service Name",
        accessor: "service",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <span>{cellProps.row.original.task.serviceName.serviceName}</span>
          )
        },
      },
      {
        Header: "Timer Started At",
        accessor: "createdAt",
        disableFilters: true,
        filterable: true,
        className: "col-2",
        Cell: cellProps => {
          return (
            <span>
              {moment(cellProps.row.original.createdAt).format(
                "DD MMM YYYY | hh:mm A"
              )}
            </span>
          )
        },
      },
    ],
    []
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable
          columns={columns}
          data={data}
          heading={"Active Employee Timer"}
        >
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>
      </PermittedComponent>
    </>
  )
}

export default ActiveTimers
